import { Power1, TweenMax } from 'gsap';
import { Sprite } from 'pixi.js';
import { GameAudio } from '../../../Config/Audio';
import SoundManager from '../../../Sound/SoundManager';
import { Animation } from '../Animation';
import Core, { GameOrientation } from '../../../Core/Core';

/**
 * Animation sequence for booster showing available pairs
 * @param pos - ui button position to align animation
 * @param c - container to add to
 */
export const showHint = async (pos: PIXI.Point, c: PIXI.Container) => {
    const magGlass = new Sprite(PIXI.utils.TextureCache['mapui/booster-hint']);

    magGlass.anchor.set(0.5);
    magGlass.x = pos.x;
    magGlass.y = pos.y;
    magGlass.rotation = 30 * (Math.PI / 180);
    c.addChild(magGlass);

    const animation = new Animation({});
    animation.add(() => SoundManager.playSound(GameAudio.BOOSTER_IN));

    if (Core.orientation === GameOrientation.PORTRAIT) {
        animation.add(
            TweenMax.to(magGlass, 0.6, {
                ease: Power1.easeOut,
                y: magGlass.y - magGlass.height * 1.5,
                rotation: 20 * (Math.PI / 180),
            })
        );
    } else {
        animation.add(
            TweenMax.to(magGlass, 0.6, {
                ease: Power1.easeOut,
                x: magGlass.x - magGlass.width * 2,
                rotation: 20 * (Math.PI / 180),
            })
        );
    }

    animation.addToLast(TweenMax.to(magGlass.scale, 0.6, { x: 1.6, y: 1.6 }));

    const endRotation =
        Core.orientation === GameOrientation.PORTRAIT
            ? 50 * (Math.PI / 180)
            : -50 * (Math.PI / 180);
    animation.add(
        TweenMax.to(magGlass, 0.3, {
            delay: 0.3,
            rotation: endRotation,
            ease: Power1.easeOut,
        })
    );
    animation.addDelay(200);
    animation.add(() => SoundManager.playSound(GameAudio.BOOSTER_OUT));

    if (Core.orientation === GameOrientation.PORTRAIT) {
        animation.add(
            TweenMax.to(magGlass, 0.4, {
                ease: Power1.easeOut,
                y: magGlass.y + magGlass.height * 1.5,
                rotation: 0,
            })
        );
    } else {
        animation.add(
            TweenMax.to(magGlass, 0.4, {
                ease: Power1.easeOut,
                x: magGlass.x + magGlass.width * 0.5,
                rotation: 0,
            })
        );
    }
    animation.addToLast(TweenMax.to(magGlass.scale, 0.3, { x: 1, y: 1 }));
    animation.add(() => magGlass.destroy());
    await animation.play();

    return 'hint shown';
};
